const OUTSTANDING_INVOICE_CUTOFF = new Date("2023-12-31T23:59:59Z")

// Member self-service checkout flows that should not surface the dashboard banner.
const SELF_SERVICE_ORDER_TYPES = ["education", "event", "pat"]

// Closed commerce orders that must not trigger the banner (M360 uses both; CCMS uses canceled).
const EXCLUDED_ORDER_STATUSES = ["canceled", "uncollectible"]

export const isPayableOutstandingOrder = order => {
  if (!order?.createdAt) return false

  const orderDate = new Date(order.createdAt)

  return (
    order.payable &&
    order.balance > 0 &&
    !EXCLUDED_ORDER_STATUSES.includes(order.status) &&
    orderDate > OUTSTANDING_INVOICE_CUTOFF
  )
}

export const orderTriggersOutstandingInvoiceBanner = order => {
  if (!isPayableOutstandingOrder(order)) return false

  if (order.orderType === "dues") return true
  if (order.staffCreated) return true

  if (SELF_SERVICE_ORDER_TYPES.includes(order.orderType)) return false

  return false
}

export const ordersTriggerOutstandingInvoiceBanner = orders =>
  orders?.some(orderTriggersOutstandingInvoiceBanner) ?? false
